/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.getDefaultBusinessId

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.getDefaultBusinessId.GetDefaultBusinessIdApi
import features.getDefaultBusinessId.models.DefaultBusiness
import features.getDefaultBusinessId.serializeGetDefaultBusinessIdState



/**
 * Get the last business chosen by the user in teh conglomerate feature [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GetDefaultBusinessIdApi")
class GetDefaultBusinessIdApiJs {

    /**
     * Get the last business chosen by the user in teh conglomerate feature
     */
    fun getDefaultBusinessId(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GetDefaultBusinessIdApi().getDefaultBusinessId(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<DefaultBusiness>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGetDefaultBusinessIdState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GetDefaultBusinessIdApi().getDefaultBusinessIdState.serializeGetDefaultBusinessIdState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
